
import Switch from '@mui/material/Switch'

import React, { Fragment as F, useContext, useEffect, useRef, useState } from 'react'
import Modal from 'react-modal'
import { toast } from 'react-toastify'

import {
  C,
  logg,
} from '$shared'

import {
  AppCtx,
} from '$src/App'
import {
  PeriodsC,
  PeriodsCtx,
} from '$src/components/periods'
import {
  IncludeUbprs,
  ReportsCtx,
  TriSelect,
} from '.'


/*
 * AddLIneitemsModal
**/
const AddLineitemsModal = (props) => {
  // logg(props, 'AddLineitemsModal')
  const {
    eol, setEol,
    lineitems, setLineitems,
    showAddLineitems, setShowAddLineitems,
  } = props

  /* ctx */


  /* state */

  const [ filteredUbprsList, setFilteredUbprsList ] = useState([])
  const [ groupByPeriod,     setGroupByPeriod ]     = useState(false)
  const [ selectedPeriods,   setSelectedPeriods ]   = useState([])
  const [ selectedUbprs,     setSelectedUbprs ]     = useState([])

  /* methods */

  const handleAdd = () => {
    const tmp = []
    logg(selectedPeriods, 'selectedPeriods')
    logg(selectedUbprs, 'selectedUbprs')
    if (Object.keys(selectedPeriods).length === 0 || selectedUbprs.length === 0) {
      toast('Please select at least one line item and at least one period to add to the report.')
      return
    }

    if (groupByPeriod) {
      Object.keys(selectedPeriods).forEach((period, period_idx) => {
        logg(period, 'period')
        selectedUbprs.forEach((ubpr, ubpr_idx) => {
          logg(ubpr, 'ubpr')
          tmp.push({...ubpr, period: period })
        })
      })
    } else {
      selectedUbprs.forEach((ubpr, ubpr_idx) => {
        Object.keys(selectedPeriods).forEach((period, period_idx) => {
          tmp.push({...ubpr, period: period })
        })
      })
    }
    setLineitems(lineitems.concat(tmp))
    setShowAddLineitems(false)
    setSelectedPeriods([])
    setSelectedUbprs([])
    eol.scrollIntoView({ behavior: 'smooth' })
  }


  return <F>
    <Modal
      ariaHideApp={false}
      className="BaseModal AddLineitemsModal "
      isOpen={showAddLineitems}
      onRequestClose={ () => setShowAddLineitems(false) }
      overlayClassName="ReportModalOverlay"
    >
      <div className='header'>
        <h5 >Add Lineitems</h5>
        <div className='close' onClick={() => {
          setShowAddLineitems(false) ;
        } }>&times;</div>
      </div>

      <div className='bifold-rows'>
        <div className='col-md-6 '>
          <div className='border-right h-100 bordered-scrolling '>

            <TriSelect {...{
              clear: () => setSelectedUbprs([]),
              filteredUbprsList, setFilteredUbprsList,
            }} />
            <IncludeUbprs {...{
              clear: () => setSelectedUbprs([]),
              eol, setEol,
              filteredUbprsList, setFilteredUbprsList,
              selectedUbprs, setSelectedUbprs,
            }} />

          </div>
        </div>
        <div className='col-md-6'>
          <div className='h-100 bordered-scrolling '>
            <div className='header'>
              <h5 >Periods</h5>
            </div>
            <PeriodsC {...{ selectedPeriods,        setSelectedPeriods, }} />
          </div>
        </div>
      </div>

      <div className='actions pt-2 pb-2 mr-3 '>
        <div className='left'></div>
        <div className='middle'>
          <label>Group by Line Item</label>
          <Switch
            checked={groupByPeriod}
            onChange={(ev) => setGroupByPeriod(!groupByPeriod) }
          />
          <label>Group by Period</label>
        </div>
        <div className='right'>
          <div className='Btn btn-primary' onClick={handleAdd} >Add</div>
        </div>
      </div>


    </Modal>
  </F>
}
export default AddLineitemsModal

